import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { commonStyleForDetail } from '../CommonStyle';
import Loader from '../Loader';
import { hot } from 'react-hot-loader';

function index(props) {
	const { classes } = props;
	return (
		<section>
			<Container component="main" maxWidth="md">
				<div className={classes.root}>
					<Grid container id="reduce-width" justify="center" spacing={5}>
						<Grid id="shadow-round" item sm={8} xs={12}>
							<Grid container id="padding-20" spacing={2}>
								{props.children}
							</Grid>
						</Grid>
					</Grid>
				</div>
			</Container>
			{props.isLoading ? <Loader /> : null}
		</section>
	);
}

export default hot(module)(withStyles(commonStyleForDetail)(index));
